const createUser = async ({ params, api }) => {
  return await api('users', { body: params.data, method: 'POST' })
    .then((res) => {
      return Promise.resolve({ data: res });
    })
};

export default createUser;